export const titleCheck = (title:String) =>{
    if (!title || title === "0") {
      return 'Title cannot be empty';
    }
    return '';
  }

export const fname = (name:String) =>{
    if (!name || name.length <= 0) {
      return 'Enter first name';
    }
    
    if (!/^[a-zA-Z ]*$/g.test(name)) {
      return 'Only alphabets are allowed';
    }
    return '';
  }

export const lname = (name:String) =>{
if (!name || name.length <= 0) {
    return 'Enter last name';
}

if (!name || name.trim().length < 2) {
    return 'Last name should be greater than 2 characters';
}
if (!/^[a-zA-Z ]*$/g.test(name)) {
    return 'Only alphabets are allowed';
  }
return '';
}


export const passportNnum = (name:String) =>{
    if (!name || name.length <= 0) {
        return 'Enter passport number';
    }

   return '';
}

export const issueCountry = (name:String) =>{
    if (!name || name.length <= 0) {
        return 'Select passport issuing country';
    }
    return '';
}

export const dateExp = (name:String) =>{
    if (!name || name.length <= 0) {
        return 'Select passport expire date';
    }
    return '';
}

export const birthDate = (name:String) =>{
    if (!name || name.length <= 0) {
        return 'Select date of birth';
    }
    return '';
}

export const panValidation = (name: String) => {

    const regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    if (!name || name.length <= 0) {
        return 'PAN number cannot be empty.';
    }

    if (!regex.test(name)) {
        return 'Please enter valid PAN number';
    }
    return '';
}

